module.exports = __webpack_public_path__ + "img/server.73ffda31.png";